/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API76054Req {
  
  /** (String) */
  bizNo?: string;
    
};



export interface API76054Res {
  /** 任务id  */
  bizNo?: string;
  /** 任务内容  */
  taskContent?: string;
  deliverList?: any[];
};


// 接口函数 76054 任务实例简易详情

export interface IUseGetAPI76054Return {
  /** 任务实例简易详情: 接口请求状态 */
  isAPI76054Loading: boolean;
  /** 任务实例简易详情: 接口请求返回数据 */
  dataAPI76054: API76054Res;
  /**  任务实例简易详情: 接口数据请求方法 */
  fetchAPI76054Data: (inputs: API76054Req, config?: YWRequestConfig) => Promise<API76054Res>;
  /** 任务实例简易详情: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76054 = ():IUseGetAPI76054Return => {
  let isMount = true;
  const [isAPI76054Loading, setIsAPI76054Loading] = useState(false);
  const [dataAPI76054, setDataAPI76054] = useState<API76054Res>({} as API76054Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/detail`;

  const fetchAPI76054Data = async (inputs: API76054Req, config?: YWRequestConfig): Promise<API76054Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76054Req>) || {}) as API76054Req;
    
  
    if ( isMount ) {
      setIsAPI76054Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76054Res>(`${basePath}/yoaichat-web/task/instance/detail?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76054(res || {} as API76054Res);
        setIsAPI76054Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76054Loading(false);
      }
      return false as unknown as API76054Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76054Loading,
    dataAPI76054,
    fetchAPI76054Data,
    requestUrl,
  }
}

